import { assign } from "lodash";
import {
  FETCH_CONNECTEDDEBTORS_REQUEST,
  FETCH_CONNECTEDDEBTORS_SUCCESS,
  FETCH_CONNECTEDDEBTORS_FAILURE
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case FETCH_CONNECTEDDEBTORS_REQUEST:
      return {
        ...state,
        id: action.payload.id,
        connectedDebtors: assign({}, state.connectedDebtors, {
          ids: [],
          loading: true,
          limit: action.payload.limit,
          ordering: action.payload.ordering
        })
      };
    case FETCH_CONNECTEDDEBTORS_SUCCESS:
      return {
        ...state,
        connectedDebtors: assign({}, state.connectedDebtors, {
          loading: false,
          ids: action.payload.items,
          count: action.payload.count,
          next: action.payload.next,
          previous: action.payload.previous
        })
      };
    case FETCH_CONNECTEDDEBTORS_FAILURE:
      return {
        ...state,
        connectedDebtors: assign({}, state.connectedDebtors, {
          loading: false
        })
      };
    default:
      return state;
  }
};
